import { MAP_SETTINGS_DRAWING_SYNC_SETTINGS } from './mapSettingsDrawing.actionTypes';

export const mapSettingsDrawingSyncSettings = () => ({
  type: MAP_SETTINGS_DRAWING_SYNC_SETTINGS,
}) as const;
